import { render, staticRenderFns } from "./CaseStudyOverlay.vue?vue&type=template&id=67d8cc43&"
import script from "./CaseStudyOverlay.vue?vue&type=script&lang=ts&"
export * from "./CaseStudyOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./CaseStudyOverlay.vue?vue&type=style&index=0&id=67d8cc43&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports